import React, {FC} from 'react';

import {
  ToolbarButton,
  ToolbarButtonProps,
} from '../../../../libs/shared/ui/src/components/buttons/toolbarButton';
import {PermissionCheck, PermissionCheckProps} from '../../../../srcCommon/permissions/permissionCheck';
import {PermissionDenied} from '../../../../srcCommon/permissions/permissionDenied';
import {PermissionDeniedReasonsEnum} from '../../../helpers/permissionHelpers';

/*
 * Props.
 */

export type PermissionToolbarButtonProps = ToolbarButtonProps & PermissionCheckProps;

/*
 * Component.
 */

export const PermissionToolbarButton: FC<PermissionToolbarButtonProps> = ({
  namespaces,
  permission,
  offlinePermission,
  bulkActionPermission,
  ...props
}) => (
  <PermissionCheck
    namespaces={namespaces}
    permission={permission}
    offlinePermission={offlinePermission}
    bulkActionPermission={bulkActionPermission}
  >
    {(permissionResult) =>
      permissionResult.isAllowed ? renderEnabled(props) : renderDisabled(props, permissionResult.reason)
    }
  </PermissionCheck>
);

function renderEnabled(props: PermissionToolbarButtonProps) {
  return <ToolbarButton {...props} />;
}

function renderDisabled(props: PermissionToolbarButtonProps, reason: PermissionDeniedReasonsEnum) {
  return (
    <ToolbarButton
      isDisabled
      iconName={props.iconName}
      label={props.label}
      renderTooltip={() => <PermissionDenied reason={reason} />}
    />
  );
}
